// eslint-disable-next-line

export default [
  {
    title: 'Test Video 1',
    description: 'Some video description',
    languages: 'German, English',
    subtitles: 'English',
    id: 1,
    manifestUri:
      'https://storage.googleapis.com/shaka-demo-assets/angel-one/dash.mpd',
  },
  {
    title: 'Test Video 2',
    description: 'Some video description',
    languages: 'German, English, Spanish',
    subtitles: 'English',
    id: 2,
    manifestUri:
      'https://storage.googleapis.com/shaka-demo-assets/sintel/dash.mpd',
  },
  {
    title: 'Test Video 3',
    description: 'Some video description',
    languages: 'English',
    subtitles: 'English',
    id: 3,
    manifestUri:
      'https://storage.googleapis.com/shaka-demo-assets/tos-ttml/dash.mpd',
  },
];



// WEBPACK FOOTER //
// ./src/videoSources.js